import { IconButton, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { TableContent, TableContentItemText } from '../../../../components/TableContent';
import { TableContentItemStatus } from '../../../../components/TableContent/status';

import { ResponsiveItemCustomerProps } from '.';

export const MobileItemTable: React.FC<ResponsiveItemCustomerProps> = ({
  item,
  detailsButtonIsDisabled,
  handlePressDetailsButton,
  detailsButtonColor,
}) => {
  return (
    <TableContent direction="column" space={Spacing['inline.xxxs']}>
      <HStack alignItems="center" justifyContent="space-between" w="full">
        <TableContentItemText variant="semibold">{item.basketOrderHash}</TableContentItemText>
        <TableContentItemStatus basketAdvisorStatus={item.basketAdvisorStatus} />
      </HStack>
      <Box h="0.5px" w="full" bg="neutral.lightest" />
      <VStack space={Spacing['stack.nano']} w="full">
        <HStack alignItems="center" justifyContent="space-between">
          <Text color="neutral.medium" fontSize={Typography['fontsize.md']}>
            Data de envio
          </Text>
          <TableContentItemText color="neutral.black">
            {item.createDateFormatted}
          </TableContentItemText>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between">
          <Text color="neutral.medium" fontSize={Typography['fontsize.md']}>
            Tipo
          </Text>
          <TableContentItemText color="neutral.black">{item.applicationType}</TableContentItemText>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between">
          <Text color="neutral.medium" fontSize={Typography['fontsize.md']}>
            Cliente
          </Text>
          <TableContentItemText color="neutral.black">{item.totalCustomers}</TableContentItemText>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between">
          <Text color="neutral.medium" fontSize={Typography['fontsize.md']}>
            Ativos
          </Text>
          <TableContentItemText color="neutral.black">{item.totalOffers}</TableContentItemText>
        </HStack>
        <HStack alignItems="center" justifyContent="space-between">
          <Text color="neutral.medium" fontSize={Typography['fontsize.md']}>
            Total investido
          </Text>
          <TableContentItemText color="neutral.black">
            {item.totalRequestedAmountFormatted}
          </TableContentItemText>
        </HStack>
      </VStack>
      <Box h="0.5px" w="full" bg="neutral.lightest" />
      <HStack justifyContent="space-between" w="full">
        <VStack space={Spacing['stack.quarck']}>
          <Text color="neutral.medium" fontSize={Typography['fontsize.xs']}>
            Última atualização
          </Text>
          <TableContentItemText color="neutral.black">
            {item.updateDateFormatted}
          </TableContentItemText>
        </VStack>
        <IconButton
          isDisabled={detailsButtonIsDisabled}
          onPress={handlePressDetailsButton}
          testId="arrow-right"
          icon="ArrowRight"
          iconColor={Color[detailsButtonColor]}
        />
      </HStack>
    </TableContent>
  );
};
